function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" {...props}><g fill="none" fillRule="evenodd" transform="translate(1 1)"><path d="M0 0h32v32H0z" /><circle cx="16" cy="16" r="16" fill="#F6F7FB" stroke="#D7DBE9" /><g fill="#6A6D7B" fillRule="nonzero"><path d="M15 9a1 1 0 1 1 2 0v14a1 1 0 0 1-2 0V9z" /><path d="M9 17a1 1 0 1 1 0-2h14a1 1 0 0 1 0 2H9z" /></g></g></svg>;
});